(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.WakeySkin = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  const dimensions = ['HYD', 'NUT', 'IMP', 'SEN', 'ECL', 'AGE', 'AOX'];
  const priorityMap = { hydratation: 'HYD', imperfections: 'IMP', age: 'AGE', eclat: 'ECL', sensibilite: 'SEN' };
  const options = {
    age: ['moins18', '18_25', '26_35', '36_45', '46_55', 'plus55'],
    environnement: ['grande_ville', 'urbain', 'petite_ville', 'campagne'],
    type: ['seche', 'mixte', 'grasse', 'normale', 'inconnue'],
    sensibilite: ['souvent', 'parfois', 'jamais'],
    deshydratation: ['souvent', 'parfois', 'non'],
    imperfections: ['regulierement', 'occasionnellement', 'jamais'],
    teint: ['terne', 'irregulier', 'lumineux', 'inconnu'],
    signes_age: ['non', 'ridules', 'rides'],
    priorite: Object.keys(priorityMap),
    secondaires: [...Object.keys(priorityMap), 'aucun']
  };
  function normalize(answers) {
    const result = {};
    for (const key of Object.keys(options)) {
      if (key === 'secondaires') {
        if (!Array.isArray(answers[key]) || !answers[key].length || answers[key].some(value => !options[key].includes(value))) throw new Error('Réponse manquante ou invalide : ' + key);
        result[key] = answers[key].includes('aucun') ? [] : [...new Set(answers[key])].filter(value => value !== answers.priorite);
      } else {
        if (!options[key].includes(answers[key])) throw new Error('Réponse manquante ou invalide : ' + key);
        result[key] = answers[key];
      }
    }
    return result;
  }
  function diagnose(input) {
    const answers = normalize(input);
    const scores = Object.fromEntries(dimensions.map(key => [key, 0]));
    const add = (key, number) => { scores[key] += number; };
    const typeScores = { seche: { HYD: 2, NUT: 4 }, mixte: { HYD: 2, IMP: 2 }, grasse: { IMP: 4 }, normale: { HYD: 1 }, inconnue: {} };
    for (const [key, number] of Object.entries(typeScores[answers.type])) add(key, number);
    add('SEN', { souvent: 5, parfois: 3, jamais: 0 }[answers.sensibilite]);
    add('HYD', { souvent: 5, parfois: 3, non: 0 }[answers.deshydratation]);
    add('IMP', { regulierement: 5, occasionnellement: 3, jamais: 0 }[answers.imperfections]);
    add('ECL', { terne: 4, irregulier: 3, lumineux: 0, inconnu: 0 }[answers.teint]);
    add('AGE', { non: 0, ridules: 3, rides: 5 }[answers.signes_age]);
    add('AGE', { moins18: 0, '18_25': 0, '26_35': 1, '36_45': 2, '46_55': 3, plus55: 3 }[answers.age]);
    add('AOX', { grande_ville: 3, urbain: 2, petite_ville: 1, campagne: 0 }[answers.environnement]);
    if (answers.environnement === 'grande_ville') add('ECL', 1);
    add(priorityMap[answers.priorite], 4);
    for (const secondary of answers.secondaires) add(priorityMap[secondary], 2);
    const ageRelevant = answers.age !== 'moins18' && (answers.signes_age !== 'non' || answers.priorite === 'age' || answers.secondaires.includes('age'));
    const effective = { ...scores, AGE: ageRelevant ? scores.AGE : 0 };
    const priority = priorityMap[answers.priorite];
    const ranking = dimensions.filter(key => effective[key] > 0).sort((a, b) => effective[b] - effective[a] || Number(b === priority) - Number(a === priority) || dimensions.indexOf(a) - dimensions.indexOf(b));
    const relevant = ranking.filter((key, index) => index === 0 || effective[key] >= 3).slice(0, 3);
    return { answers, scores, effective, ranking: relevant, main: relevant[0] || 'HYD', secondary: relevant[1] || null, complementary: relevant[2] || null, ageRelevant, sensitive: scores.SEN >= 5, minor: answers.age === 'moins18' };
  }
  function eligible(product, diagnostic) {
    const profile = product.profile;
    const { answers } = diagnostic;
    if (!product.available || !product.variant || !profile || profile.enabled !== true || profile.intensive) return false;
    if (!profile.skin_types.includes(answers.type)) return false;
    if (diagnostic.minor && (profile.adult_only || profile.essential_oils)) return false;
    if (diagnostic.sensitive && (!profile.sensitive_approved || profile.essential_oils || !profile.composition_verified)) return false;
    if (!diagnostic.ageRelevant && profile.weights.AGE >= 2) return false;
    if (profile.purifying && (answers.type === 'seche' || diagnostic.sensitive || (answers.type === 'inconnue' && diagnostic.effective.IMP < 7))) return false;
    return true;
  }
  function matchScore(product, diagnostic) {
    if (!eligible(product, diagnostic)) return -Infinity;
    const profile = product.profile;
    const max = Math.max(1, ...Object.values(diagnostic.effective));
    let value = dimensions.reduce((sum, key) => sum + (diagnostic.effective[key] / max) * Number(profile.weights[key] || 0) * 10, 0);
    if (profile.weights[diagnostic.main] > 0) value += profile.weights[diagnostic.main] * 3;
    if (diagnostic.answers.type === 'seche') value += profile.richness * 5;
    if (['mixte', 'grasse'].includes(diagnostic.answers.type)) value += (2 - profile.richness) * 3;
    if (diagnostic.answers.type === 'inconnue') value -= profile.richness * 3;
    if (diagnostic.sensitive) value += profile.fragrance === false ? 12 : -8;
    else if (diagnostic.answers.sensibilite === 'parfois') value -= profile.essential_oils ? 12 : (profile.fragrance === true ? 2 : 0);
    if (profile.category === 'spf' && /50/.test(product.title)) value += 5;
    return value;
  }
  function pick(products, diagnostic, categories, predicate = () => true) {
    return products.filter(product => categories.includes(product.profile?.category) && eligible(product, diagnostic) && predicate(product)).sort((a,b) => matchScore(b, diagnostic) - matchScore(a, diagnostic) || a.variant.price - b.variant.price || a.handle.localeCompare(b.handle))[0] || null;
  }
  function recommend(products, diagnostic) {
    const distinct = [...new Map(products.map(product => [String(product.id), product])).values()];
    const cleanser = pick(distinct, diagnostic, ['nettoyant']);
    const cream = pick(distinct, diagnostic, ['creme'], product => product.profile.periods.includes('matin') && product.profile.periods.includes('soir'));
    const spf = pick(distinct, diagnostic, ['spf']);
    const serum = pick(distinct, diagnostic, ['serum'], product => product.profile.periods.includes('matin'));
    const complement = pick(distinct, diagnostic, diagnostic.effective.NUT >= 4 || diagnostic.sensitive ? ['huile'] : ['masque']);
    const essential = [cleanser, cream, spf].filter(Boolean);
    const complete = [cleanser, serum, cream, spf, complement].filter(Boolean);
    const morning = [cleanser, serum, cream, spf].filter(Boolean).filter(product => product.profile.periods.includes('matin'));
    const evening = [cleanser, serum, cream, complement].filter(Boolean).filter(product => product.profile.periods.includes('soir'));
    return { essential, complete, morning, evening, missing: [['nettoyant',cleanser],['creme',cream],['spf',spf]].filter(([,product]) => !product).map(([category]) => category) };
  }
  function total(products) {
    return products.reduce((sum, product) => sum + Number(product.variant.price), 0);
  }
  function cartItems(products) {
    return [...new Map(products.map(product => [String(product.variant.id), { id: String(product.variant.id), quantity: 1 }])).values()];
  }
  return { dimensions, priorityMap, options, normalize, diagnose, eligible, matchScore, recommend, total, cartItems };
});
